module.exports = __webpack_public_path__ + "img/STAR_app_campus_DA.5a4253c6.png";